import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

type RefundPolicyContentProps = {
  embedded?: boolean;
};

export function RefundPolicyContent({ embedded = false }: RefundPolicyContentProps) {
  const { t } = useTranslation();
  const cancellationRules = t('legal.pages.refundPolicy.cancellationRules', {
    returnObjects: true,
  }) as string[];

  return (
    <div className={embedded ? '' : 'max-w-3xl mx-auto px-4 py-12 sm:py-16'}>
      {!embedded && (
        <>
          <p className="mb-2 text-xs uppercase tracking-widest text-textSecondary">
            {t('legal.badge')}
          </p>
          <h1 className="mb-4 text-3xl font-semibold text-textPrimary">
            {t('legal.pages.refundPolicy.title')}
          </h1>
        </>
      )}

      <p className="mb-6 leading-relaxed text-textSecondary">
        {t('legal.pages.refundPolicy.intro')}
      </p>

      <section className="mb-7">
        <h2 className="mb-3 text-lg font-semibold text-textPrimary">
          {t('legal.pages.refundPolicy.cancellationTitle')}
        </h2>
        <ul className="list-disc space-y-2 pl-5 text-textSecondary">
          {Array.isArray(cancellationRules)
            && cancellationRules.map((rule) => <li key={rule}>{rule}</li>)}
        </ul>
      </section>

      <section className="mb-7">
        <h2 className="mb-3 text-lg font-semibold text-textPrimary">
          {t('legal.pages.refundPolicy.requestTitle')}
        </h2>
        <p className="leading-relaxed text-textSecondary">
          {t('legal.pages.refundPolicy.requestDescription')}
        </p>
      </section>

      <div className="rounded-lg border border-gray-200 bg-gray-50 p-4 text-sm text-textSecondary">
        <p>{t('legal.pages.refundPolicy.exceptions')}</p>
        <p className="mt-3 text-xs">{t('legal.pages.refundPolicy.disclaimer')}</p>
      </div>

      {!embedded && (
        <Link to="/" className="fo-link mt-8 inline-block">
          {t('legal.backHome')}
        </Link>
      )}
    </div>
  );
}

export function RefundPolicyPage() {
  return <RefundPolicyContent />;
}
